/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { getFormatDateHour } from '../../../utils/date';
import useForm from '../../../hooks/useForm';
import Modal, { ModalHeader } from '../../../components/Modal';
import Form from '../../../components/Form';
import { addCollaboration, editCollaboration, getCollaboration } from '../../../apis/tax-portal/tax-consulting';
import { toast } from '../../../utils/toast';
import { isEmpty } from '../../../utils/lodashExtend';
import Comment from '../../../components/Comment';
import { useSelector } from 'react-redux';
import systemAlert from '../../../utils/systemAlert';
const defaultForm = {
  title: "",// 제목
  content: "", // 내용
  fileIdxes: []
};
const TaxConsultingCollaborationDetail = ({ data, selectedItem, open, setOpen, submit, orgMode, categoryName, categoryIdx }) => {
  const { employee } = useSelector((store) => ({
    employee: store.Profile.employee,
  }));
  const [mode, setMode] = useState(orgMode);
  const [fields, setFields] = useState([]);
  const [buttons, setButtons] = useState([]);

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    resetForm(defaultForm);
    submit && submit();
  };

  const _submit = (form) => {
    if (mode === "create") {
      const params = {
        ...form,
        categoryIdx,
        targetEmployeeIdx: selectedItem?.employeeIdx || selectedItem.idx,
        ...data,
      };

      systemAlert(`${categoryName} 협업을 ${selectedItem.name}에게 하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '요청',
            onClick: () => {
              addCollaboration(params).then(res => {
                toast.success("요청이 완료되었습니다.");
                submit && submit();
                cancel();
              });
            }
          }
        ]
      });

    } else if (mode === "modify") {


      const params = {
        title: form.title,
        content: form.content,
        fileIdxes: form.fileIdxes
      };

      systemAlert(`${form.targetCompany?.name}에게 요청한 ${categoryName} 협업을 정말 수정하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '수정',
            onClick: () => {
              editCollaboration(form.idx, params).then(res => {
                toast.success("수정이 완료되었습니다.");
                submit && submit();
                cancel();
              });
            }
          }
        ]
      });
    }
  };

  const {
    form,
    errors,
    handleSubmit,
    handleOnChange,
    setForm,
    resetForm,
    setOriginForm,
    setValidateFields
  } = useForm(
    defaultForm,
    _submit
  );

  useEffect(() => {
    setFields([
      [
        {
          isHide: mode !== "view",
          title: mode !== "view" && "작성자", key: "employee.name",
          className: "mt-10"
        },
        {
          isHide: mode !== "view",
          title: mode !== "view" && "작성일시", key: "createdTime",
          className: "text-align-right color-gray-5",
          onValue: (data) => {
            return `작성일 : ${getFormatDateHour(data)} `;
          }
        },
      ],
      {
        isHide: mode !== "view",
        type: "line"
      },
      [
        {
          isHide: () => {
            return mode === "view";
          },
          title: "제목",
          key: "title",
          type: "input",
          required: true,
          readOnly: mode === "modify" ? true : false
        },
      ],
      [
        {
          className: "min-heihgt-200",
          title: mode !== "view" && "내용",
          key: "content",
          type: "editor",
        },
      ],
      {
        type: "line"
      },
      [
        {
          title: "첨부파일",
          key: "fileIdxes",
          type: "dropzone",
        },
      ],
      {
        isHide: mode !== "view",
        type: "reaction",
        params: {
          postIdx: "idx",
          postType: "tax_consulting"
        },
        fullWidth: true
      },
    ]);

  }, [mode]);

  useEffect(() => {
    setButtons([
      {
        color: "text",
        label: "닫기",
        onClick: cancel
      },
      {
        isHide: mode !== "modify",
        label: "수정",
        onClick: handleSubmit
      },
      {
        isHide: mode !== "view" || data.writerEmployeeIdx !== employee.idx,
        label: "수정하기",
        onClick: () => setMode("modify")
      },
      {
        isHide: mode !== "create",
        label: "협업 요청하기",
        onClick: handleSubmit
      }
    ]);
  }, [mode, employee]);

  useEffect(() => {
    if (!isEmpty(data)) {
      const form = {
        ...data,
        fileIdxes: data.uploadFiles,
      };

      setForm(form);
      setOriginForm(form);
      setMode(orgMode);
    }
  }, [data]);

  useEffect(() => {
    if (!isEmpty(fields)) {
      setValidateFields(fields);
    }
  }, [fields]);

  useEffect(() => {
    if (orgMode === "view" && !isEmpty(data)) {
      getCollaboration(data.idx);
    }
  }, [open, data, orgMode, categoryName]);

  return (
    <>
      <Modal
        isOpen={open}
        close={cancel}
      >
        <ModalHeader>
          {`${categoryName}`}
          {mode === "create" ? ` ${selectedItem?.name} 협업 요청 하기` : ""}
          {mode === "view" ? ` ${data?.employee?.company?.name} 협업 요청` : ""}
          {mode === "modify" ? ` ${data?.employee?.company?.name} 협업 요청 수정` : ""}
        </ModalHeader>
        <Form
          mode={mode}
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          buttons={buttons}
        >
          {mode === 'view' && data && (
            <div className="file-upload-list">
              <div className="file-upload-form">
                <Comment
                  postIdx={data.idx}
                  postType="tax_consulting_collaboration"
                  submit={() => { }}
                  isFirstSubmit={false}
                  param={{
                    companyIdx: data.companyIdx,
                    title: data.title.length <= 7 ? data.title : data.title.substr(0, 7) + ".."
                  }}
                  isReadCheck={true}
                />
              </div>
            </div>
          )}
        </Form>

      </Modal>
    </>
  );
};

export default TaxConsultingCollaborationDetail;